import { graphql, useStaticQuery } from "gatsby";
import { IPartner, IPartnerBodyItem } from "../interfaces/partners";
import { link } from "fs";
import { PilotProgramTypes } from "../types/pilotProgram";



export const getPartners = (): IPartner[] => {
    const query = graphql`
    query  {
      allPrismicPartners (
        sort: { data: { priority: ASC }}
      ) {
        nodes {
          id
          data {
            logo {
                alt
                copyright
                url
                gatsbyImageData
            }
            title {
              text
            }
            description {
              text
            }
            body {
              ... on PrismicPartnersDataBodyPartner {
                items {
                  site_url {
                    target
                    url
                  }
                  tag {
                    text
                  }
                  partner_logo {
                    alt
                    copyright
                    url
                    gatsbyImageData
                  }
                  is_pilot_program_partner  
                }
              }
            }
          }
        }
      }
    }
    `;
    const data = useStaticQuery(query)
    const { allPrismicPartners } = data || {};
    const { nodes } = allPrismicPartners || []
    return nodes;
};


export const getPartnersPilotPrograms = (): PilotProgramTypes[] => {
    const partners = getPartners();
    const pilotPrograms: IPartnerBodyItem[] = [];

    partners.forEach((element: IPartner) => {
        const items = element.data?.body?.flatMap(bodyItem =>
            bodyItem.items?.filter(item => item.is_pilot_program_partner) || []
        );

        if (items && items.length) {
            pilotPrograms.push(...items);
        }
    });

    const res = pilotPrograms.map((item, index) => ({
      image: item.partner_logo,
      tag: item.tag?.text,
      link: item.site_url,
      id: index
    } as PilotProgramTypes));
    return res;
};